import {PostType} from '../type.d';
import http from '../services/http';

class Api {
  static test() {
    return http.get(
      `/test`,
    )
  }
  static loginGoogle(data:PostType) {
    return http.post(
      `/login_google`,
      data,
    )
  }
  static checkSession() {
    return http.get(
      `/api/session`
    )
  }
  static activity() {
    return http.get(
      `/api/activity`,
    )
  }
  static deleteActivity(data:any) {
    return http.post(
      `/api/activity-delete`,
      data,
    )
  }
  static getGmailLoginLink() {
    return http.post(
      `/api/get-gmail-login-link`,
      {},
    )
  }
  static getSlackLoginLink() {
    return http.post(
      `/api/get-slack-login-link`,
      {},
    )
  }
  static getConnectionLinks() {
    return http.get(
      `/api/oauth-links`,
      )
  }
  static getSubscriptions() {
    return http.get(
      `/api/get-subscriptions`,
    )
  }
  static checkIndexStatus(email:string) {
    return http.get(`/api/teams-data-status?email=${email}`)
  }
  static getSlackMembers() {
    return http.get(
      `/api/get-members`,

    )
  }
  static searchData(text: string, subscriptions: Array<any>){
    return http.post(
      `/api/search`,
      {
        "query": text,
        "subscriptions": subscriptions
      },
    )
  }
  static mqSearch(text:string) {
    return http.post('/api/mq-search', { query: text })
  }
  static pageSearch(page: string|number, searchId:string, platform:string, cancelToken?:any) {
    const pl = platform === 'all' ? platform.toUpperCase() : platform;
    return http.get(`/api/page?page=${page || 0}&search_id=${searchId}&platform=${pl}`, {
      cancelToken: cancelToken ? cancelToken.token : null,
    })
  }
  static getSearchSuggestions(trovaId:string, query:string) {
    return http.post(
      '/api/suggest',
      {
        trova_id: trovaId,
        query,
      }
    )
  }
  static getBookmarks() {
    return http.get(
      `/api/bookmark`,
    )
  }
  static postBookmark(data:any) {
    return http.post(
      `/api/bookmark`,
      data,
    )
  }
  static deleteBookmark(data:any) {
    return http.post(
      `/api/bookmark-delete`,
      data,
    )
  }
  static searchFeedback(data:any) {
    return http.post(
      `/api/search-feedback`,
      data,
    )
  }
  static getPermalink(data:any) {
    return http.post(
      `/api/get-permalink`,
      data,
    )
  }
  static deleteUser() {
    return http.get(
      `/api/delete-user`,
    )
  }
  static disconnectAccount(data:any) {
    return http.post(
      `/api/disconnect-account`,
      data,
    )
  }
  static getGoogleSSO() {
    return http.get(`/google-sso`);
  }
  static inviteMembers(emails:string[]) {
    return http.post(`/api/invite`, emails);
  }
  static betaSignup(email:string) {
    return http.post(`/beta-signup`,
      { email })
  }

  static getToken(code:string) {
    return http.get(`/token?code=${code}`);
  }

  static trackClick(data:any) {
    return http.post('/api/userclick', data);
  }

  static getFullGmail(data:any) {
    return http.post('/api/fetchSingleMessage', data);
  }
}

export default Api;